import { render, staticRenderFns } from "./NumberComponent.vue?vue&type=template&id=20da36d8&scoped=true&"
import script from "./NumberComponent.vue?vue&type=script&lang=js&"
export * from "./NumberComponent.vue?vue&type=script&lang=js&"
import style0 from "./NumberComponent.vue?vue&type=style&index=0&id=20da36d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da36d8",
  null
  
)

export default component.exports